import React from "react";
import PropTypes from "prop-types";
import { Alert, Button, Grid } from "@mui/material";
import { memberTypeList } from "./memberTypes";
import MemberTypeCard from "./MemberTypeCard";
import useAuth from "../../../../hooks/useAuth";

function SelectMemberTypeStep({ onSelect }) {
  const { isAdmin, isSuperAdmin } = useAuth();
  const canUseExistingContract = isAdmin || isSuperAdmin;
  const allowedTypes = canUseExistingContract
    ? memberTypeList
    : memberTypeList.filter((item) => item.type !== "addMemberToContract");

  return (
    <div style={{ padding: "0px" }}>
      {!canUseExistingContract && (
        <Alert severity="info" sx={{ mb: 2 }}>
          Das Hinzufügen zu bestehenden Verträgen ist nur für Admins verfügbar.
        </Alert>
      )}
      <Grid container direction="row" justify="space-between" spacing={3}>
        {allowedTypes &&
          allowedTypes.map((memberType, i) => {
            return (
              <Grid
                item
                style={{
                  display: "flex",
                }}
                justify="center"
                key={i}
                lg={4}
                xs={12}
              >
                <MemberTypeCard memberType={memberType}>
                  <Button
                    color="secondary"
                    variant="contained"
                    style={{ width: "100%", minHeight: "60px", fontSize: 20 }}
                    onClick={() => onSelect(memberType.type)}
                  >
                    Auswählen
                  </Button>
                </MemberTypeCard>
              </Grid>
            );
          })}
      </Grid>
    </div>
  );
}

SelectMemberTypeStep.propTypes = {
  onSelect: PropTypes.func,
};

export default SelectMemberTypeStep;
